import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DIContextProvider } from "./config/di/dependency_injection_context";
import { LicenseInfo } from "@mui/x-license";
import { SliderContainerContextProvider } from "./common/contexts/slider_container_context";
import { BrowserRouter } from "react-router";

import ReactDOM from "react-dom/client";
import Router from "./routes/Router";
import AppProvider from "./common/contexts/app_context/app_provider";
import UserAuthProvider from "./common/contexts/user_auth_context/user_auth_provider";

import dayjs from "dayjs";
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc";

import "dayjs/locale/pt-br";

import "./styles/index.css";

import "font-awesome/css/font-awesome.css";

import "@fontsource/roboto/300.css";
import "@fontsource/roboto/400.css";
import "@fontsource/roboto/500.css";
import "@fontsource/roboto/700.css";

dayjs.extend(duration);
dayjs.extend(utc);

// O aviso "ResizeObserver loop ..." é inofensivo (comum com DataGrid/Autocomplete do MUI),
// mas a overlay de erros do react-scripts o exibe como erro em desenvolvimento.
// O listener em fase de captura roda antes da overlay e descarta apenas essa mensagem.
if (process.env.NODE_ENV === "development") {
  window.addEventListener(
    "error",
    (e) => {
      if (typeof e.message === "string" && e.message.startsWith("ResizeObserver loop")) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    },
    true,
  );
}

if (process.env.REACT_APP_MUI_PRO_KEY) {
  LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_PRO_KEY);
}

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

root.render(
  <BrowserRouter>
    <AppProvider>
      <DIContextProvider>
        <SliderContainerContextProvider>
          <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="pt-br">
            <UserAuthProvider>
              <Router />
            </UserAuthProvider>
          </LocalizationProvider>
        </SliderContainerContextProvider>
      </DIContextProvider>
    </AppProvider>
  </BrowserRouter>
);
